// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderSmall_loader__rSrEa","spin":"LoaderSmall_spin__zsLIX"};